import { render, staticRenderFns } from "./IMRHome.vue?vue&type=template&id=5faa4b84&scoped=true"
import script from "./IMRHome.vue?vue&type=script&lang=js"
export * from "./IMRHome.vue?vue&type=script&lang=js"
import style0 from "./IMRHome.vue?vue&type=style&index=0&id=5faa4b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa4b84",
  null
  
)

export default component.exports